<template>
    <div class="videoResume ml-3 mr-3 ml-lg-5">
        <div class="card p-4 pl-lg-5" v-if="profileVideoDetails === null || profileVideoDetails.videoLink === null || ( (getuserid != loginuserid) && profileVideoDetails.visibility === 'PRIVATE')">
            <div class="card-body col-12 text-center pt-5 pb-5">
                <div class="p-2 d-flex flex-column text-center">
                    <img src="../../assets/no_video.svg" width="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                    <span class="oopsnext proximanova">Video Profile not available</span>
                </div>
            </div>
        </div>
        <div class="col-12 pl-0 pr-0 mb-4 card introvideocard mt-lg-4"  v-else>
            <div class="card overlay-gradient">
                <div class="mx-auto">
                    <video height="450" oncontextmenu="return false" :src="profileVideoDetails.videoLink" class="borderradius10" controlsList="nodownload"  id="profileVideo1" ></video>
                </div>
                <div class="card-img-overlay p-0">
                    <div class="row no-gutters mb-3 ml-0 mr-0 pb-3 companyvid_overlay1 borderradius10">
                        <div class="col pl-3 pr-3 mt-2 d-flex videoheadsection">
                            <img src="../../assets/VideoProfile.svg" alt="video" class="" width="30px" />
                            <div class="d-flex flex-column ml-2">
                                <span class="ml-2 mr-2 proximanova-semibold fontsize14 white">{{profileDetails.firstName}} {{profileDetails.lastName}}</span>
                                <span class="ml-2 mr-2 proximanova-thin fontsize12 white">Video Profile</span>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3 my-auto">
                        <img src="../../assets/play_video.svg" v-if="!playingProfileVideo" class="playpausevideobtn" alt="playvideo" @click="playProfileVideo">
                        <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="playingProfileVideo && replayProfileVideo">
                            <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayVideo()">
                        </div>
                        <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="playingProfileVideo && loadingProfileVideo">
                            <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="loading">
                        </div>
                        <img src="../../assets/Pausevideo.svg" class="playpausevideobtn pausebtn" v-if="playingProfileVideo && !replayProfileVideo && !loadingProfileVideo" alt="pausevideo" @click="playProfileVideo">
                    </div>
                    <div class="bottom">
                        <div class="companyvid_overlay2 borderradius10">
                            <div class="pl-3 pr-3 pb-3 d-flex flex-column">
                                <span class="fontsize14 white proximanova-semibold" v-if="profileVideoDetails.videoTitle"> {{profileVideoDetails.videoTitle}}</span>
                                <span v-if="profileVideoDetails.videoDescription" class="fontsize14 white60 proximanova-thin text-capitalize">{{profileVideoDetails.videoDescription}}</span>
                                <!-- <span class="float-right btn button-create shadow backgroundcolorblack p-1 pl-2 mb-5 mouseoverbtn2 pr-2 borderradius20 white">
                                    <span class="proximanova ml-1 fontsize16">Get in Touch <span class="fontsize10">( Coming Soon )</span></span> 
                                </span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import sessionUtils from '@/js/session-util.js'
import httpuserprofile from "@/js/http-userprofile.js";
import { bus } from "../../main";
export default {
    props : [
        'userProfileDetails'
    ],
    data() {
        return{
            loginuserid : sessionUtils.getUserId(),
            // loginuserid : 5,
            loginuserprofileid : sessionUtils.getUserProfileId(),
            getuserid : null,
            profileId : null,
            profileDetails : null,
            profileVideoDetails : null,
            profileVideoId : null,
            playingProfileVideo : false,
            replayProfileVideo : false,
            loadingProfileVideo : false,
            currentRoute : null,
        }
    },
    created()  {
        bus.$on('stopPlayingselecteduserProfileVideo', (data) => {
            this.playingProfileVideo = data;
        })
    },
    mounted(){
        this.profileDetails = this.userProfileDetails;
        this.profileId = this.userProfileDetails.profileId;
        this.getuserid = this.userProfileDetails.userId;
        this.profileVideoId = this.userProfileDetails.profileVideoId;
        this.profileVideoDetails = this.userProfileDetails.profileVideoDetails;
        this.currentRoute = this.$route.name;
    },
    methods : {
        // this will invoke after click on play/pause button on team video card to play/pause the video
        playProfileVideo : function() {
            var that = this;
            var video = document.getElementById('profileVideo1')
            var totalSec;
            if(video){
                totalSec = Math.round(video.duration)
            }
            if(!this.playingProfileVideo) {
                this.playingProfileVideo = true
                video.play()
                let viewedSec = 0
                if(this.currentRoute != 'selectedloginviewuserprofile'){
                    this.viewprofileVideo(viewedSec, totalSec)
                }
            }else{
                this.playingProfileVideo = false;
                video.pause()
                let percent = video.currentTime;
                percent = Math.round(percent)
                if(this.currentRoute != 'selectedloginviewuserprofile'){
                    this.viewprofileVideo(percent, totalSec)
                }
            }
            video.onended = videoEnded;
            video.oncanplay = stopLoadingLogo;
            video.onwaiting = displayLoadingLogo;
            function videoEnded() {
                that.playingProfileVideo = true;
                that.replayProfileVideo = true;
                that.loadingProfileVideo = false;
                let percent = video.currentTime;
                percent = Math.round(percent)
                if(this.currentRoute != 'selectedloginviewuserprofile'){
                    that.viewprofileVideo(percent, totalSec)
                }
            }
            function stopLoadingLogo() {
                if(that.playingProfileVideo){
                that.loadingProfileVideo = false;
                }
            }
            function displayLoadingLogo() {
                if(that.playingProfileVideo){
                that.loadingProfileVideo = true;
                }
            } 
        },
        replayVideo() {
            this.replayProfileVideo = false;
            this.loadingProfileVideo = false;
            this.playingProfileVideo = false;
            this.playProfileVideo()
        },
        viewprofileVideo: function(viewedSec, totalSec){
            var fd = new FormData(); 
            var obj = {
                profileId : this.loginuserprofileid,
                videoId: this.profileVideoId,
                videoProfileId: this.profileId,
                viewed_sec : viewedSec,
                video_type : 'PROFILEVIDEO'
            }
            console.log("obj : ", obj)
            let videoTotalSec = totalSec
            var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
            fd.append("userVideoViews", blob)
            fd.append("duration", videoTotalSec)
            httpuserprofile.post("/userprofile/viewVideo", fd, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Accept" : "*/*"
                }
            }).then(response => {
                console.log(response)                          
            }) .catch((e) => {
                console.log(e)
            }) 
        }
    },
    beforeDestroy() {
        bus.$off('stopPlayingselecteduserProfileVideo')
    }
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.playpausevideobtn{
  margin-left: 46%;
  margin-top: 40%;
  cursor: pointer;
}
.pausebtn{
  display: none;
}
.introvideocard:hover .pausebtn{
  display: block;
  margin-top: 46% !important;
}
#profileVideo1{
  width: 260px;
}
.bottom{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
#playvideobtn {
  /* display: none; */
  margin-left: 46%;
  margin-top: 46% !important;
  cursor: pointer;
}
.companyvid_overlay1{
	background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
}
.companyvid_overlay2{
	background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%);
}
@media screen and (min-width: 600px) {
  .no-video {
    width: 45%;
    align-self: center;
  }
}
</style>